// pages/FormViewerPage/hooks/useFormViewer/bump.ts — load + seleksi bump fisik
import { useEffect, useState } from 'react';
import { supabase } from '../../../../supabase/client';
import { buildBumpOptions, bumpTotals, bumpWeightGrams, type BumpOption } from '../../../../utils/bumpPricing';

export function useBump(form: any) {
  const [bumpOptions, setBumpOptions] = useState<BumpOption[]>([]);
  const [selectedBumpIds, setSelectedBumpIds] = useState<string[]>([]);

  useEffect(() => {
    const cfg = (form?.bumpProducts || []) as Array<{ productId: string; bumpPrice?: number | null; autoSelect?: boolean; label?: string }>;
    if (!cfg.length || !form?.brandId) {
      setBumpOptions([]);
      setSelectedBumpIds([]);
      return;
    }
    const ids = [...new Set(cfg.map((b) => b.productId).filter(Boolean))];
    (async () => {
      try {
        // Tabel products fisik = snake_case (brand_id, base_price) — beda dgn digital_products.
        // Berat = sumber Daftar Produk (attributes.weight), dipakai hitung ongkir total.
        const { data, error } = await supabase
          .from('products')
          .select('id, name, base_price, attributes')
          .in('id', ids)
          .eq('brand_id', form.brandId)
          .eq('status', 'active');
        if (error || !data?.length) {
          setBumpOptions([]);
          setSelectedBumpIds([]);
          return;
        }
        const rows = (data as any[]).map((r: any) => ({ id: r.id, name: r.name, basePrice: Number(r.base_price) || 0, weightGrams: Number(r?.attributes?.weight) || 0 }));
        setBumpOptions(buildBumpOptions(cfg, rows));
        setSelectedBumpIds(cfg.filter((b) => b.autoSelect === true).map((b) => b.productId).filter((id) => rows.some((r) => r.id === id)));
      } catch {
        setBumpOptions([]);
        setSelectedBumpIds([]);
      }
    })();
  }, [form?.id, (form as any)?.brandId, JSON.stringify((form as any)?.bumpProducts || [])]);

  const toggleBump = (id: string) =>
    setSelectedBumpIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  const { sum: bumpSum, discount: bumpDiscount } = bumpTotals(bumpOptions, selectedBumpIds);
  const bumpWeight = bumpWeightGrams(bumpOptions, selectedBumpIds);
  return { bumpOptions, selectedBumpIds, toggleBump, bumpSum, bumpDiscount, bumpWeight };
}

export type BumpState = ReturnType<typeof useBump>;
